import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {Card} from '@veneer/core';

import {FormErrors, OIDCLoginConfiguration, Party} from '../../types';
import {OIDCLinks} from '../shared/OIDCLinks';

import ExtraLoginLink from './ExtraLoginLink';
import LoginUsername from './LoginUsername';

const LoginOptions = ({
    loginConfiguration,
    errors,
    initialUsername,
}: {
    loginConfiguration: OIDCLoginConfiguration;
    errors: FormErrors;
    initialUsername: string;
}): JSX.Element => {
    const hasOidc = loginConfiguration.oidc_logins.length > 0;
    const allowPasswordLogin = loginConfiguration.allow_password_login;
    const showPartnerLogin =
        loginConfiguration.partner_login_enabled && loginConfiguration.for_party === Party.Customer;
    const showConsumerLogin = loginConfiguration.for_party === Party.Partner;
    const {t} = useTranslation(['login']);

    return (
        <Card
            style={{
                width: '380px',
            }}
            className="p-5"
            appearance="dropShadow"
            content={
                <>
                    {allowPasswordLogin ? (
                        <LoginUsername
                            errors={errors}
                            initialUsername={initialUsername}
                        />
                    ) : null}
                    {allowPasswordLogin && hasOidc ? (
                        <hr
                            style={{
                                width: '72px',
                                margin: '36px auto',
                                border: 'transparent',
                                borderTop: '1px solid #e6e6e6',
                            }}
                        />
                    ) : null}
                    {hasOidc && <OIDCLinks oidcLogins={loginConfiguration.oidc_logins} />}
                    {hasOidc && (showConsumerLogin || showPartnerLogin) && (
                        <div className="mt-4">
                            {showPartnerLogin && (
                                <ExtraLoginLink
                                    url={loginConfiguration.urls.partner_login}
                                    name={t('login:partnerLoginTitle', 'Partner login')}
                                />
                            )}
                            {showConsumerLogin && (
                                <ExtraLoginLink
                                    url={loginConfiguration.urls.customer_login}
                                    name={t('login:customerLogInTitle', 'Customer login')}
                                />
                            )}
                        </div>
                    )}
                    {!allowPasswordLogin && !hasOidc ? (
                        <div>
                            <Trans i18nKey="login:unavailable">
                                <p>Online login is currently unavailable.</p>
                                <p>Please try again later.</p>
                            </Trans>
                        </div>
                    ) : null}
                </>
            }
        />
    );
};

export default LoginOptions;
